import { render, staticRenderFns } from "./TrainingExam.vue?vue&type=template&id=732ca99c"
import script from "./TrainingExam.vue?vue&type=script&lang=js"
export * from "./TrainingExam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports